<template>
  <div class="row f-row" id="infoBoxTA">
    <table
      class="table table-sm table-borderless ta_table"
      style="width: 100%;"
    >
      <tbody>
        <tr class="txt-label-primary-5">
          <th class="txt-label-primary-5" style="width: 5rem!important">
            {{ dateTitle }}
          </th>
          <th class="txt-label-primary-5">
            Open:
          </th>
          <th class="txt-label-primary-5">
            High:
          </th>
          <th class="txt-label-primary-5">
            Low:
          </th>
          <th class="txt-label-primary-5">
            Last:
          </th>
          <th class="txt-label-primary-5">
            Last vs Open:
          </th>
          <th class="txt-label-primary-5" v-show="show20ma">MA {{ ma1 }}:</th>
          <th class="txt-label-primary-5" v-show="show40ma">MA {{ ma2 }}:</th>
          <th class="txt-label-primary-5" v-show="show3ma">MA {{ ma3 }}:</th>
          <th class="txt-label-primary-5" v-show="showBoll">
            Upper:
          </th>
          <th class="txt-label-primary-5" v-show="showBoll">
            Lower:
          </th>
        </tr>
        <tr>
          <td class="txt-label-primary" style="width: 5rem!important">
            <div class="txt-label-primary-3 text-center">
              {{ priceLegend["date"] | dateFormat }}
            </div>
          </td>
          <td class="txt-label-primary">
            <div
              class="candle-hover-info text-center"
              style="background: var(--expo-alpha-3); border-bottom: 1px solid var(--expo-alpha-4);"
            >
              {{ priceLegend["open"] | priceFormat }}
            </div>
          </td>
          <td class="txt-label-primary">
            <div
              class="candle-hover-info  text-center"
              style="background: var(--expo-alpha-3); border-bottom: 1px solid var(--expo-alpha-4);"
            >
              {{ priceLegend["high"] | priceFormat }}
            </div>
          </td>
          <td class="txt-label-primary">
            <div
              class="candle-hover-info text-center"
              style="background: var(--expo-alpha-3); border-bottom: 1px solid var(--expo-alpha-4);"
            >
              {{ priceLegend["low"] | priceFormat }}
            </div>
          </td>
          <td class="txt-label-primary">
            <div
              class="candle-hover-info text-center"
              style="background: var(--expo-alpha-3); border-bottom: 1px solid var(--expo-alpha-4);"
            >
              {{ priceLegend["close"] | priceFormat }}
            </div>
          </td>
          <td class="txt-label-primary">
            <div
              class="candle-hover-info text-center"
              style="background: var(--expo-alpha-3); border-bottom: 1px solid var(--expo-alpha-4);"
            >
              {{ priceLegend["change"] | percFormat }}
            </div>
          </td>
          <td class="txt-label-primary" v-show="show20ma">
            <div
              id="infoma20TA"
              class="candle-hover-info text-center"
              style="background: var(--net-alpha-2); border-bottom: 1px solid var(--net-alpha);"
            >
              -
            </div>
          </td>
          <td class="txt-label-primary" v-show="show40ma">
            <div
              id="infoma40TA"
              class="candle-hover-info text-center"
              style="background: var(--red-alpha-2); border-bottom: 1px solid var(--red-alpha);"
            >
              -
            </div>
          </td>
          <td class="txt-label-primary" v-show="show3ma">
            <div
              id="infoma3TA"
              class="candle-hover-info text-center"
              style="background: var(--fwd-alpha-2); border-bottom: 1px solid var(--fwd-alpha);"
            >
              -
            </div>
          </td>
          <td class="txt-label-primary" v-show="showBoll">
            <div
              id="infobollupTA"
              class="candle-hover-info text-center"
              style="background: var(--hedge-alpha-3); border-bottom: 1px solid var(--hedge-alpha);"
            >
              -
            </div>
          </td>
          <td class="txt-label-primary" v-show="showBoll">
            <div
              id="infobolldownTA"
              class="candle-hover-info text-center"
              style="background: var(--hedge-alpha-3); border-bottom: 1px solid var(--hedge-alpha);"
            >
              -
            </div>
          </td>
          <!--          <td class="txt-label-primary">-->
          <!--            <div id="inforsiTA" class="candle-hover-info text-center">-</div>-->
          <!--          </td>-->
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { format, timeFormat } from "d3";
import { formatPercent } from "@/_core/_helpers/_parametric_tools";

export default {
  name: "TechnicalAnalysisInfo",
  props: {
    dateTitle: { required: true },
    priceLegend: {
      required: true,
      default: {
        date: "...",
        open: "...",
        high: "...",
        low: "...",
        close: "...",
        change: "...",
      },
    },
    show20ma: { required: true },
    show40ma: { required: true },
    show3ma: { required: true },
    ma1: { required: true },
    ma2: { required: true },
    ma3: { required: true },
    showBoll: { required: true },
  },
  filters: {
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.4r")(val);
    },
    percFormat: function(val) {
      return val === null || val === 0 ? "-" : formatPercent(val);
    },
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
  },
};
</script>
